import { render } from "./FormEditSubcourse.vue?vue&type=template&id=5c8195db&scoped=true"
import script from "./FormEditSubcourse.vue?vue&type=script&lang=js"
export * from "./FormEditSubcourse.vue?vue&type=script&lang=js"

import "./FormEditSubcourse.vue?vue&type=style&index=0&id=5c8195db&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8195db"]])

export default __exports__